import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Typography } from '@material-ui/core';
import approvalConstraints from '../../constants/approvalConstraints';
import FormCheckBoxWithLabel from '../legacyForm/FormCheckBoxWithLabel';

const required = value => value ? undefined : 'Zgoda jest wymagana';

const VotingApprovals = ({ approvals, approvalConstraintOption, onApprovalConstraintPick }) => (
  <React.Fragment>
    {approvals && approvals.length
      ? <React.Fragment>
          {approvals.filter(a => a.appliesTo === approvalConstraints.all.value).map(approval => (
            <div key={approval.id}>
              <Field
                name={`approval_${approval.id}`}
                component={FormCheckBoxWithLabel}
                label={<div className="approval" dangerouslySetInnerHTML={{__html: approval.value}} />}
                fullWidth
                validate={required}
              />
            </div>
          ))}

          {!approvalConstraintOption && approvals.filter(a => a.appliesTo !== approvalConstraints.all.value).length ?
            <React.Fragment>
              <div className="row" style={{justifyContent: 'center'}}>
                <a href="#" onClick={e => {onApprovalConstraintPick(approvalConstraints.minors.value); e.preventDefault();}} className="col-sm-6 col-md-4 obszar-link">
                  <div className="inner-wrapper">
                    <p>Wymagana zgoda rodzica/opiekuna prawnego</p>
                    <span href="#" className="btn">Wybierz</span>
                  </div>
                </a>
                <a href="#" onClick={e => {onApprovalConstraintPick(approvalConstraints.adults.value); e.preventDefault();}} className="col-sm-6 col-md-4 obszar-link">
                  <div className="inner-wrapper">
                    <p>Niewymagana zgoda rodzica/opiekuna prawnego</p>
                    <span href="#" className="btn">Wybierz</span>
                  </div>
                </a>
              </div>
              <Typography variant="caption" display="block" style={{marginTop: 16}}>Wymagane jest wybranie jednej opcji</Typography>
            </React.Fragment>
            : null}
          {approvalConstraintOption ?
            approvals.filter(a => a.appliesTo === approvalConstraintOption).map(approval => (
              <div key={approval.id}>
                <Field
                  name={`approval_${approval.id}`}
                  component={FormCheckBoxWithLabel}
                  label={<div className="approval" dangerouslySetInnerHTML={{__html: approval.value}} />}
                  fullWidth
                  validate={required}
                />
              </div>
            ))
          : null}
      </React.Fragment>
      : null}
  </React.Fragment>
);

VotingApprovals.propTypes = {
  approvals: PropTypes.array,
  approvalConstraintOption: PropTypes.string,
  onApprovalConstraintPick : PropTypes.func,
};

export default VotingApprovals;


// WEBPACK FOOTER //
// ./src/components/budget/VotingApprovals.js